import React from 'react';
import MobileLogoBlock from './MobileLogoBlock';
import images from '../images';
import useAuth from '../hooks/useAuth';
import {useLocation} from "react-router-dom";
import {logout} from "../api/auth.sso";
import {useNotifications} from "../context/NotificationsContext";

const MobileHeaderTop = () => {
  const { logout: contextLogout } = useAuth();
  const location = useLocation();
  const { openNotifications } = useNotifications();


  const handleRulesClick = () => {
    window.open('https://docs.google.com/document/d/1tarscKtoRJdB8ZndtuVDLQdgfOq8Qz4hEboO46dv_ng/edit?tab=t.0', '_blank', 'noopener,noreferrer');
  };

  const parseUserIdFromPath = () => {
    const pathParts = location.pathname.split('/');
    // Путь может быть /advertisers/profile/6 или /advertisers/flows/6 или /advertisers/leads/6
    const idIndex = pathParts.indexOf('profile');
    if (idIndex === -1) {
      const flowsIndex = pathParts.indexOf('flows');
      const leadsIndex = pathParts.indexOf('leads');
      if (flowsIndex !== -1) return pathParts[flowsIndex + 1];
      if (leadsIndex !== -1) return pathParts[leadsIndex + 1];
    }
    return idIndex !== -1 ? pathParts[idIndex + 1] : null;
  };

  const selectedUserId = parseUserIdFromPath();

  const getViewNotifications = (pathname) => {
    if (pathname.includes('/advertisers/profile') || pathname.includes('/advertisers/leads') || pathname.includes('/advertisers/flows')) {
      return true;
    } else {
      return false;
    }
  };

  const viewNotifications = getViewNotifications(location.pathname);

  const handleOpenNotificationsModal = () => {
    openNotifications(selectedUserId);
  };

  const handleLogout = async () => {
    try {
      await logout();
      contextLogout();
    } catch (error) {
      console.error('Ошибка при выходе:', error);
    }
  };

  return (
    <div className="mobile-header-top">
      <MobileLogoBlock />

      <div className="header-top-actions">
        {
            viewNotifications && (
                <button className="header-action-btn" onClick={() => handleOpenNotificationsModal()}>
                  <img src={images.bellBold} alt="" className="header-action-icon"/>
                </button>
            )
        }
        <button
            className="header-action-btn"
            onClick={handleRulesClick}
        >
          <img src={images.question} alt="Правила" className="header-action-icon"/>
        </button>
        <button className="header-action-btn" onClick={handleLogout}>
          <img src={images.exitLinear} alt="" className="header-action-icon"/>
        </button>
      </div>
    </div>
  );
};

export default MobileHeaderTop;
